export const CURRENT = 'current'
export const HISTORY = 'history'

export const HISTORY_DATE_FORMATE = 'D MMM YYYY, H:mm'
export const HISTORY_DATE_FORMAT_2 = 'D MMM, YYYY'

export const SNAPSHOTS_URI = '/snapshots'
export const CURRENT_URI = `${SNAPSHOTS_URI}/${CURRENT}`
